import { render } from "./BroadcastMessages.vue?vue&type=template&id=13c1d8d0"
import script from "./BroadcastMessages.vue?vue&type=script&lang=js"
export * from "./BroadcastMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__